import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <g clipPath="url(#clip0_2683_2700)">
      <path
        d="M9 9.01055C9 8.73139 9.22553 8.50586 9.50469 8.50586H10.7664C12.0202 8.50586 13.0375 9.52312 13.0375 10.777C13.0375 11.7043 12.4823 12.5008 11.6859 12.8541L12.4965 14.8791C12.6006 15.1378 12.4745 15.4311 12.2158 15.5352C11.9572 15.6393 11.6638 15.5131 11.5597 15.2545L10.6765 13.048H10.0094V15.0668C10.0094 15.346 9.78384 15.5715 9.50469 15.5715C9.22553 15.5715 9 15.346 9 15.0668V9.01055ZM10.0094 12.0387H10.7664C11.4635 12.0387 12.0281 11.4741 12.0281 10.777C12.0281 10.0799 11.4635 9.51523 10.7664 9.51523H10.0094V12.0387ZM14.0469 10.5246H15.3086C16.2848 10.5246 17.075 11.3148 17.075 12.291C17.075 13.2673 16.2848 14.0574 15.3086 14.0574H14.5516V15.5715C14.5516 15.8506 14.326 16.0762 14.0469 16.0762C13.7677 16.0762 13.5422 15.8506 13.5422 15.5715V11.0293C13.5422 10.7501 13.7677 10.5246 14.0469 10.5246ZM15.3086 13.048C15.7265 13.048 16.0656 12.709 16.0656 12.291C16.0656 11.8731 15.7265 11.534 15.3086 11.534H14.5516V13.048H15.3086Z"
        fill={fill}
      />
    </g>
    <circle cx="12.5" cy="12.5" r="7.65" stroke={fill} strokeWidth="1.7" />
    <defs>
      <clipPath id="clip0_2683_2700">
        <rect
          width="8.075"
          height="8.075"
          fill={fill}
          transform="translate(9 8)"
        />
      </clipPath>
    </defs>
  </g>
);

export default Icon;
